export const IconArrowSorting: {
  name: 'icon_arrow_sorting-bc41970ea6ae'
} = {
  name: 'icon_arrow_sorting-bc41970ea6ae'
}
